import apiService from '../api';

const quizApiStudentMixin = {
  /**
   * Get student's quiz assignments
   */
  async getStudentAssignments(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);

    const queryString = queryParams.toString();
    return apiService.request(`/quizzes/student/assignments${queryString ? `?${queryString}` : ''}`);
  },

  /**
   * Start quiz attempt
   */
  async startAttempt(assignmentId) {
    return apiService.request(`/quizzes/student/assignments/${assignmentId}/start`, {
      method: 'POST'
    });
  },

  /**
   * Get existing quiz attempt
   */
  async getAttempt(attemptId) {
    return apiService.request(`/quizzes/student/attempts/${attemptId}`);
  },

  /**
   * Save quiz response
   */
  async saveResponse(attemptId, responseData) {
    return apiService.request(`/quizzes/student/attempts/${attemptId}/response`, {
      method: 'POST',
      skipVersionCheck: true,
      body: JSON.stringify(responseData)
    });
  },

  /**
   * Upload (or replace) a PDF attachment for a short_answer/essay response
   */
  async uploadQuizAttachment(attemptId, questionId, { fileName, fileData }) {
    return apiService.request(`/quizzes/student/attempts/${attemptId}/responses/${questionId}/attachment`, {
      method: 'PUT',
      skipVersionCheck: true,
      body: JSON.stringify({ fileName, fileData })
    });
  },

  /**
   * Remove a previously uploaded attachment
   */
  async deleteQuizAttachment(attemptId, questionId) {
    return apiService.request(`/quizzes/student/attempts/${attemptId}/responses/${questionId}/attachment`, {
      method: 'DELETE',
      skipVersionCheck: true
    });
  },

  /**
   * Submit quiz attempt
   */
  async submitAttempt(attemptId) {
    const response = await apiService.request(`/quizzes/student/attempts/${attemptId}/submit`, {
      method: 'POST',
      skipVersionCheck: true,
      timeout: 120000
    });
    return response;
  },

  /**
   * Auto-submit quiz attempt (for single-attempt quizzes when user leaves)
   */
  async autoSubmitAttempt(attemptId) {
    return apiService.request(`/quizzes/student/attempts/${attemptId}/auto-submit`, {
      method: 'POST',
      skipVersionCheck: true,
      timeout: 120000
    });
  },

  /**
   * Get attempt result
   */
  async getAttemptResult(attemptId) {
    const response = await apiService.request(`/quizzes/student/attempts/${attemptId}/result`);
    return response;
  },
};

export default quizApiStudentMixin;
